<template class="menu-item-cost">
  <v-menu
    v-model="menu"
    :class="{ 'v-menu__activator--disabled': isLoading }"
    :close-on-content-click="false"
    :open-on-click="false"
    min-width="325"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="isLoading"
      flat
      @click="openMenu($event)"
    >
      <span class="toolbar__button-label">
        <span v-if="!isSelected" class="autocomplete__text">
          {{ $t(`Common.by`) | capitalizeFirstLetter }} {{ $t(`Common.${type}`) | textLowercase }}
        </span>

        <span v-else class="autocomplete__text autocomplete__text--active">
          {{ selectedItem.name | ellipsis(15) }}
        </span>
      </span>

      <v-icon
        v-if="!isSelected"
        class="autocomplete__arrow"
        color="gray-6"
        right
        small
      >
        keyboard_arrow_down
      </v-icon>

      <v-icon
        v-if="isSelected"
        class="autocomplete__arrow"
        data-id="menu-item__clear"
        color="accent"
        right
        small
        @click="() => { updateFilters(null), clearSelectedItem() }"
      >
        close
      </v-icon>
    </v-btn>

    <v-list
      class="py-0"
      two-line
    >
      <v-list-tile>
        <AutoCompleteAsync
          :label="`${$t(`Common.searchBy`)} ${$t(`Common.${type}`)}`"
          :service="type === 'employee' || type === 'supervisor' ? 'employee' : type"
          :input="filters[type]"
          :clear="clear"
          @change="updateFilters($event)"
        />
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import AutoCompleteAsync from '@/components/AutoCompleteAsync.vue'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isObject } from 'utils/functions'

export default {
  components: {
    AutoCompleteAsync
  },
  props: {
    type: String,
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      menu: false,
      isSelected: false,
      title: null,
      filters: {},
      selectedItem: null,
      clear: false
    }
  },
  mounted () {
    this.title = this.type
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    openMenu (e) {
      this.menu = e.target.dataset.id !== 'menu-item__clear'
    },

    clearSelectedItem () {
      this.clear = !this.clear
    },

    updateFilters (val) {
      const id = this.isValidObject(val) ? val.id : null
      let obj = {}

      this.isSelected = this.isValidObject(val)
      this.menu = false
      this.selectedItem = val

      if (this.type === 'costCenter') obj = { costCenterId: id }
      if (this.type === 'project') obj = { projectId: id }
      if (this.type === 'supervisor') obj = { supervisorId: id }
      if (this.type === 'employee') obj = { employeeId: id }
      if (this.type === 'company') obj = { companyId: id }

      this.$emit('change', obj)
    }
  }
}
</script>

<style lang="scss">
.v-menu__activator {
  opacity: 1;
  transition: opacity .26s;
}

.v-menu__activator--disabled .v-menu__activator {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>
